import { Component, Input, ChangeDetectionStrategy, inject } from "@angular/core";
import { DEFAULT_EMPTY_URL } from "../constants";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
    selector: 'ev-pdf-viewer',
    template: `<iframe [src]="getSrc()" [width]="width" [height]="height"></iframe>`,
    changeDetection: ChangeDetectionStrategy.Eager
})
export class EvPdfViewerComponent {
    private domSanitizer = inject(DomSanitizer);

    @Input() src: string
    @Input() width: string = '100%'
    @Input() height: string = '100%'

    getSrc() {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(this.src || DEFAULT_EMPTY_URL)
    }
}
